import React, { useEffect, useState, useCallback } from 'react';
import Layout from '../reporting_utils/Layout';
import useFiltersState from '../reporting_utils/useFiltersState';
import { getFilterValues } from '../reporting_utils/misc';
import { Common } from '../../utils/common';
import DataTable from '../reporting_utils/DataTable';

const pageLoadingFrame = window.pageLoadingFrame;

const defaultFilterState = {};

export default function ActiveCampaigns() {
  const [tableData, setTableData] = useState([]);
  const [filters, setFilters] = useFiltersState(defaultFilterState);

  const fetchTableData = useCallback(async () => {
    if (!filters.domains) {
      return;
    }
    pageLoadingFrame('show');
    try {
      const res = await fetch('/admin/integration_report', {
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(getFilterValues(filters)),
      });
      const data = await res.json();
      setTableData(data.tableData);
    } catch (error) {
      console.error(error);
      Common.notify('Failed to fetch report data', 'error');
    }
    pageLoadingFrame('hide');
  }, [filters]);

  useEffect(() => {
    fetchTableData();
  }, [fetchTableData]);

  return (
    <Layout
      title='Integration Report'
      fetchData={fetchTableData}
      filters={filters}
      setFilters={setFilters}
      defaultFilterState={defaultFilterState}
      datePickerMode='none'
    >
      <DataTable
        title='Integration Report'
        columnDefs={[
          { title: 'Action ID', data: 'action_id' },
          { title: 'Domain ID', data: 'domain_id' },
          { title: 'Location Name', data: 'location_name' },
          { title: 'Webhook Name', data: 'name' },
          { title: 'URL', data: 'url' },
          {
            title: 'Headers',
            data: 'headers',
            render(data) {
              return `<pre>${data}</pre>`;
            },
          },
          { title: 'Success Code', data: 'success_code' },
        ]}
        data={tableData}
      />
    </Layout>
  );
}
